module.exports = "/_next/static/chromiums/apple-touch-startup-750x1334-image-bdb12cbbb7b074746ce285f8732a1c28.png";